module.exports = __webpack_public_path__ + "weathericons-regular-webfont.1cd48d78f06d33973d9d.woff2";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/weather-icons/fonts/weathericons-regular-webfont.woff2
// module id = ../../../../../src/assets/scss/icons/weather-icons/fonts/weathericons-regular-webfont.woff2
// module chunks = styles